import React from 'react'

const FileIcon = ({ fill = '#8F8F8F', ...props }) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M10.5338 1.47333C10.2604 1.2 9.78711 1.38667 9.78711 1.76667V4.09333C9.78711 5.06667 10.6138 5.87333 11.6204 5.87333C12.2538 5.88 13.1338 5.88 13.8871 5.88C14.2671 5.88 14.4671 5.43333 14.2004 5.16667C13.2404 4.2 11.5204 2.46 10.5338 1.47333Z'
        fill={fill}
      />
      <path
        d='M13.667 6.79333H11.7403C10.1603 6.79333 8.87366 5.50666 8.87366 3.92666V1.99999C8.87366 1.63333 8.57366 1.33333 8.20699 1.33333H5.38033C3.32699 1.33333 1.66699 2.66666 1.66699 5.04666V10.9533C1.66699 13.3333 3.32699 14.6667 5.38033 14.6667H10.6203C12.6737 14.6667 14.3337 13.3333 14.3337 10.9533V7.45999C14.3337 7.09333 14.0337 6.79333 13.667 6.79333ZM7.66699 11.8333H5.00033C4.72699 11.8333 4.50033 11.6067 4.50033 11.3333C4.50033 11.06 4.72699 10.8333 5.00033 10.8333H7.66699C7.94033 10.8333 8.16699 11.06 8.16699 11.3333C8.16699 11.6067 7.94033 11.8333 7.66699 11.8333ZM9.00033 9.16666H5.00033C4.72699 9.16666 4.50033 8.94 4.50033 8.66666C4.50033 8.39333 4.72699 8.16666 5.00033 8.16666H9.00033C9.27366 8.16666 9.50033 8.39333 9.50033 8.66666C9.50033 8.94 9.27366 9.16666 9.00033 9.16666Z'
        fill={fill}
      />
    </svg>
  )
}

export default FileIcon
